<template>
  <div>
    <vs-card style="
        display: block;
        margin: auto;
        min-width: 350px;
        max-width: 350px;
        margin-top: 12%;
        border-radius: 10px;
      ">
      <div>
        <div class="p-2">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <a href="/login" class="logo logo-admin">
                  <img src="https://www.ausa.com.mx/img/logo-ver2.png" height="80" alt="logo"
                    style="display: block; margin: auto" />
                </a>
              </div>
              <div class="col-md-12" style="top: 30px">
                <h4 class="login-title-text" style="text-align: center"></h4>
              </div>
            </div>
          </div>
        </div>

        <div class="p-1">
          <div class="container">
            <div class="row">
              <div class="col-md-12" style="top: 30px">
                <p class="password-recovery-title-text" style="text-align: left">
                  {{ bloqueoMsg }}
                </p>
              </div>
            </div>
          </div>

          <div class="text-center row m-t-20" v-if="!enviarSMSStatus && correoInfo != ''">
            <div class="col-12">
              <br />
              <button @click="enviarCorreoDesbloqueo()" v-if="!loading"
                class="vs-button-primary vs-button-border btn-block vs-button">
                <p class="mb-0">
                  <vs-icon size="12px" icon="email"></vs-icon>
                  <span> Enviar código al correo</span>
                </p>
                <span> {{ formattedMail }}</span>
              </button>
            </div>
          </div>

          <div class="text-center row m-t-0" v-if="!enviarSMSStatus && correoInfo != '' && numeroInfo != ''"
            style="margin-left: 65px; margin-right: 65px;">
            <div class="col-12" style="padding: 10px!important;" v-if="!loading">
              <div class="separator"> ó </div>
            </div>
          </div>

          <div class="text-center row m-t-0" v-if="!enviarSMSStatus && numeroInfo != ''">
            <div class="col-12">
              <button @click="enviarMensajeDesbloqueo()" v-if="!loading"
                class="vs-button-primary vs-button-border btn-block vs-button">
                <p class="mb-0">
                  <vs-icon size="12px" icon="phone_iphone"></vs-icon>
                  <span> Enviar código al numero</span>
                </p>
                <span> {{ formattedNumber }}</span>
              </button>
            </div>
          </div>

          <div class="text-center row m-t-2" v-if="!enviarSMSStatus">
            <div class="col-12">
              <br />
              <button v-if="loading" class="vs-button-primary vs-button-filled btn-block vs-button" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Procesando...
              </button>
            </div>
          </div>

          <div class="text-center row mt-5" v-if="enviarSMSStatus">
            <div class="col-12">
              <p class="password-recovery-title-text" style="text-align: left">
                Ingresa el código de verificación
              </p>
              <v-otp-input length="6" v-model="codeText"></v-otp-input>
            </div>

            <div class="col-12">
              <br />
              <button @click="verificarCodigoDesbloqueo()" v-if="!loading" :disabled="canClickVerficar ? false : true"
                class="vs-button-primary vs-button-filled btn-block vs-button">
                <span> Verificar Código </span>
              </button>
              <button v-else class="vs-button-primary vs-button-filled btn-block vs-button" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Procesando...
              </button>
            </div>

            <div v-if="showReenvio == false">
              <p class="re-enviar-text-style" @click="habilitarReenvio()">
                No recibí el código
              </p>
            </div>

            <div class="col-12" v-if="showReenvio == true">
              <button @click="reenviarCodigo()" class="vs-button-dark vs-button-filled btn-block vs-button"
                :disabled="!canclickReenviar">
                <b v-if="!canclickReenviar"> {{ buttonText }}s </b> <span> Reenviar código </span>
              </button>
            </div>

          </div>
        </div>
      </div>
      <div slot="footer" style="margin-top: -30px">
        <!--<vs-row vs-justify="center">
            <p style="text-align:center; margin-bottom: 50px;" class="text-muted">Login hecho para el ambiente de desarrollo local. <br/>Si usted esta viendo este login comuniquese a <b>desarrollo@ausa.com.mx</b></p>
        </vs-row>-->
        <br />
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoginService from "@/services/login/login.service.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
export default {
  title() {
    return this.$route.meta.title
  },
  components: {},
  data() {
    return {
      enviarSMSStatus: false,

      bloqueoData: null,
      bloqueoMsg: null,
      keyInfo: null,

      numeroInfo: null,
      correoInfo: null,

      username: "",
      newCodeCount: null,
      showReenvio: false,


      formattedNumber: "",
      formattedMail: "",
      codeText: "",

      buttonText: "",
      countdown: 120,

      canclickReenviar: false,


      canClickVerficar: false,

      loading: false,
      desbloqueoPor: null,
    };
  },
  computed: {
    ...mapState(["domain", "informationPage"]),
  },
  mounted() {
    this.bloqueoData = this.$route.params.bloqueoData;
    this.numeroInfo = this.$route.params.numeroInfo;
    this.correoInfo = this.$route.params.correoInfo;
    this.username = this.$route.params.uslogin;
    this.bloqueoMsg = this.$route.params.bloqueoMsg;

    this.formatData();
  },
  methods: {
    formatData() {
      var numberString = this.numeroInfo.toString();
      var correoString = this.correoInfo.toString();

      if (numberString != "") {
        this.formattedNumber =
          numberString.slice(0, 2) + numberString.slice(2).replace(/.(?=...)/g, "*");
      }

      if (correoString != "") {
        this.formattedMail =
          correoString.slice(0, 2) + correoString.slice(2).replace(/.(?=...)/g, "*");
      }
    },

    habilitarReenvio() {
      this.showReenvio = true;
      this.canclickReenviar = true;
    },

    async enviarMensajeDesbloqueo() {
      this.loading = true;
      this.desbloqueoPor = 'sms'
      let response = await LoginService.enviarSmsDesbloqueoLogin(
        this.bloqueoData
      );
      if (response["error"] == false) {
        this.enviarSMSStatus = true;
      } else {
        this.enviarSMSStatus = true;
        this.$vs.notify({
          title: "Oops.. ",
          text: response["msg"],
          color: "danger",
          icon: "cancel",
          position: "bottom-center",
          time: 10000,
        });
      }
      this.loading = false;
    },

    async reenviarMensajeDesbloqueo() {
      this.desbloqueoPor = 'sms'
      let response = await LoginService.enviarSmsDesbloqueoLogin(
        this.bloqueoData
      );
      if (response["error"] == false) {
        this.enviarSMSStatus = true;
      } else {
        this.enviarSMSStatus = true;
        this.$vs.notify({
          title: "Oops.. ",
          text: response["msg"],
          color: "danger",
          icon: "cancel",
          position: "bottom-center",
          time: 10000,
        });
      }
    },

    async reenviarCodigo() {
      this.canclickReenviar = false;
      this.startCountdown();
      if (this.desbloqueoPor == 'sms') {
        this.reenviarMensajeDesbloqueo();
      } else {
        this.reenviarCorreoDesbloqueo();
      }
    },

    async enviarCorreoDesbloqueo() {
      this.loading = true;
      this.desbloqueoPor = 'correo'
      let response = await LoginService.enviarCorreoDesbloqueoLogin(
        this.bloqueoData
      );
      if (response["error"] == false) {
        this.enviarSMSStatus = true;
      } else {
        this.enviarSMSStatus = true;
        this.$vs.notify({
          title: "Oops.. ",
          text: response["msg"],
          color: "danger",
          icon: "cancel",
          position: "bottom-center",
          time: 10000,
        });
      }
      this.loading = false;
    },

    async reenviarCorreoDesbloqueo() {
      this.desbloqueoPor = 'correo'
      let response = await LoginService.enviarCorreoDesbloqueoLogin(
        this.bloqueoData
      );
      if (response["error"] == false) {
        this.enviarSMSStatus = true;
      } else {
        this.enviarSMSStatus = true;
        this.$vs.notify({
          title: "Oops.. ",
          text: response["msg"],
          color: "danger",
          icon: "cancel",
          position: "bottom-center",
          time: 10000,
        });
      }
    },

    async verificarCodigoDesbloqueo() {
      this.loading = true;
      let response = await LoginService.validarCodigoDesbloqueoLogin(
        this.codeText,
        this.username,
        this.bloqueoData,
      );
      if (response["error"] == false) {
        this.$vs.notify({
          title: "Validado!",
          text: "Se retiró el bloqueo a su cuenta, por favor vuelva a iniciar sesión",
          color: "success",
          icon: "check_circle",
          position: "bottom-center",
          time: 10000,
        });
        this.$router.push({
          name: "login",
        });
      } else {
        this.$vs.notify({
          title: "Oops.. ",
          text: "Parece que el código ingresado es incorrecto, por favor vuelva a intentarlo",
          color: "danger",
          icon: "cancel",
          position: "bottom-center",
          time: 10000,
        });
      }
      this.loading = false;
    },

    startCountdown() {
      if (this.countdown === 120) {
        this.buttonText = this.countdown;
        const interval = setInterval(() => {
          this.countdown--;
          if (this.countdown > 0) {
            this.buttonText = this.countdown;
          } else {
            this.buttonText = '';
            clearInterval(interval);
            this.canclickReenviar = true;
            this.countdown = 120; // Reset for next use
          }
        }, 1000);
      }
    },

  },

  watch: {
    codeText(val) {
      if (val.length == 6) {
        this.canClickVerficar = true;
      } else {
        this.canClickVerficar = false;
      }
    },
  },
};
</script>

<style scoped>
.re-enviar-text-style {
  padding-left: 20px;
  text-decoration: underline;
  cursor: pointer;
  color: cornflowerblue;
}

.login-title-text {
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 0px;
  color: #757575 !important;
}

.password-recovery-title-text {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0px;
  color: #9e9e9e !important;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #11489b;
}

.separator:not(:empty)::before {
  margin-right: .25em;
}

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
